export default "__VITE_ASSET__BSCmefr9__"